import { html, htmlArray, css } from "../helpers/webComponents";
import { GameRouteService } from "../services/GameRouteService";

const styles: string = css`
a {
    text-decoration: none;
    color: #f5d6ca;
}
.image-character {
    height: 10rem;
    width: auto;
}

.lose {
    color: red;
    font-size: 4em;
}
.win {
    color: green;
    font-size: 4em;
}
.accusationOption {
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 10px;
    margin-top: 5%;
    background: rgba(41, 35, 35, 0.85);
}
game-accusate {
    width: 100%;
}
.accusedWrong, .accusedRight, .accusationOption, characters {
    text-align: center;
    align-items: center;
}
button {
    background: transparent;
    border: none;
}
body {
    font-family: sans-serif;
    margin: 0;
    height: 100vh;
    background-color: #0b0b0b;
    color: white;
    display: flex;
    align-items: center;
    
}
:host {
    font-family: "Onesize";
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto calc(35vh + 10px) minmax(calc(35vh + 10px), 1fr) auto;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
}
`;

export class AccusationComponent extends HTMLElement {
    private readonly _gameRouteService: GameRouteService = new GameRouteService();

    public characterName: string = "";
    public _inventoryCount: number = 0;

    /**
     * The "constructor" of a Web Component
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        void this.render();
    }

    /**
     * Render the chef character and an eventlistener on the picture to go to the lose page
     * @returns a HTMLElement containing a picture of the chef wrapped in a button
     */
    private renderChef(): HTMLElement {
        const chefCharacter: HTMLElement = html`
        <button>
            <img class="image-character" src="/assets/img/rooms/Chef.png" alt="chef">
        </button>
    `;
        chefCharacter.addEventListener("click", () => {
            this.characterName = "Chef";
            this.backgroundImageCharacter();
            if (this.shadowRoot) {
                if (this.shadowRoot.querySelector(".accusationOption")) {
                    const element: HTMLElement = this.shadowRoot.querySelector(".accusationOption")!;
                    element.hidden = true;
                }
            }
            if (this.shadowRoot) {
                if (this.shadowRoot.querySelector(".accusedWrong")) {
                    const element: HTMLElement = this.shadowRoot.querySelector(".accusedWrong")!;
                    element.hidden = false;
                }
            }
            this.showAccusationMonologue();
        });
        return chefCharacter;
    }

    /**
     * Render the butler character and an eventlistener on the picture to go to the lose page
     * * @returns a HTMLElement containing a picture of the butler wrapped in a button
     */
    private renderButler(): HTMLElement {
        const butlerCharacter: HTMLElement = html`
            <button>
                <img class="image-character" src="/assets/img/rooms/butler.png" alt="butler">
            </button>
        `;
        butlerCharacter.addEventListener("click", () => {
            this.characterName = "butler";
            this.backgroundImageCharacter();
            if (this.shadowRoot) {
                if (this.shadowRoot.querySelector(".accusationOption")) {
                    const element: HTMLElement = this.shadowRoot.querySelector(".accusationOption")!;
                    element.hidden = true;
                }
            }
            if (this.shadowRoot) {
                if (this.shadowRoot.querySelector(".accusedWrong")) {
                    const element: HTMLElement = this.shadowRoot.querySelector(".accusedWrong")!;
                    element.hidden = false;
                }
            }
            this.showAccusationMonologue();
        });
        return butlerCharacter;
    }

    /**
     * Render the business partner character and an eventlistener on the picture to go to the lose page
     * * @returns a HTMLElement containing a picture of the business partner wrapped in a button
     */
    private renderBusinessPartner(): HTMLElement {
        const businessPartnerCharacter: HTMLElement = html`
        <button>
            <img class="image-character" src="/assets/img/rooms/BusinessPartner.png" alt="business partner">
        </button>
        `;
        businessPartnerCharacter.addEventListener("click", () => {
            this.characterName = "BusinessPartner";
            this.backgroundImageCharacter();
            if (this.shadowRoot) {
                if (this.shadowRoot.querySelector(".accusationOption")) {
                    const element: HTMLElement = this.shadowRoot.querySelector(".accusationOption")!;
                    element.hidden = true;
                }
            }
            if (this.shadowRoot) {
                if (this.shadowRoot.querySelector(".accusedWrong")) {
                    const element: HTMLElement = this.shadowRoot.querySelector(".accusedWrong")!;
                    element.hidden = false;
                }
            }
            this.showAccusationMonologue();
        });
        return businessPartnerCharacter;
    }

    /**
    * Render the business partner character and an eventlistener on the picture to go to the lose page
    * * @returns a HTMLElement containing a picture of the gardener wrapped in a button
    */
    private renderGardener(): HTMLElement {
        const gardenerCharacter: HTMLElement = html`
        <button>
            <img class="image-character" src="/assets/img/rooms/Gardener.png" alt="gardener">
        </button>
        `;
        gardenerCharacter.addEventListener("click", () => {
            this.characterName = "Gardener";
            this.backgroundImageCharacter();
            if (this.shadowRoot) {
                if (this.shadowRoot.querySelector(".accusationOption")) {
                    const element: HTMLElement = this.shadowRoot.querySelector(".accusationOption")!;
                    element.hidden = true;
                }
            }
            if (this.shadowRoot) {
                if (this.shadowRoot.querySelector(".accusedWrong")) {
                    const element: HTMLElement = this.shadowRoot.querySelector(".accusedWrong")!;
                    element.hidden = false;
                }
            }
            this.showAccusationMonologue();
        });
        return gardenerCharacter;
    }

    /**
     * Render the widow character and an eventlistener on the picture to go to the win page
     * * @returns a HTMLElement containing a picture of the widow wrapped in a button
     */
    private renderWidow(): HTMLElement {
        const widowCharacter: HTMLElement = html`
        <button>
            <img class="image-character" src="/assets/img/rooms/elizabeth.png" alt="widow">
        </button>
        `;
        widowCharacter.addEventListener("click", () => {
            this.characterName = "elizabeth";
            this.backgroundImageCharacter();
            if (this.shadowRoot) {
                if (this.shadowRoot.querySelector(".accusationOption")) {
                    const element: HTMLElement = this.shadowRoot.querySelector(".accusationOption")!;
                    element.hidden = true;
                }
            }
            if (this.shadowRoot) {
                if (this.shadowRoot.querySelector(".accusedRight")) {
                    const element: HTMLElement = this.shadowRoot.querySelector(".accusedRight")!;
                    element.hidden = false;
                }
            }
            this.showAccusationMonologue();
        });
        return widowCharacter;
    }

    /**
     * Render the characters on the accusation page
     */
    private renderCharacters(): HTMLElement[] {
        const chefCharacter: HTMLElement = this.renderChef();
        const butlerCharacter: HTMLElement = this.renderButler();
        const businessPartnerCharacter: HTMLElement = this.renderBusinessPartner();
        const widowCharacter: HTMLElement = this.renderWidow();
        const gardenerCharacter: HTMLElement = this.renderGardener();
        return [chefCharacter, butlerCharacter, businessPartnerCharacter, widowCharacter, gardenerCharacter];
    };

    /**
     * Handles the clearing of the localStorage and sends you to the landing page
     */
    private playAgain(): HTMLElement {
        const element: HTMLElement = html`
            <p>Click <a href="#" id="resetGame">here</a> to go back to the default page.</p>
        `;

        element.addEventListener("click", async () => {
            const elapsed: number = parseInt(localStorage.getItem("elapsed_time") || "0", 10);
            const username: string | null = localStorage.getItem("username");

            if (username && elapsed > 4) {
                try {
                    await this._gameRouteService.submitDuration(elapsed, username);
                    console.log("✅ Submitted duration before reset:", elapsed, username);
                }
                catch (error) {
                    console.error("❌ Failed to submit duration on reset:", error);
                }
            }
            else {
                console.warn("⛔ Username or elapsed time missing — skipping duration submit.");
            }

            // Now safely reset everything
            localStorage.clear();
            location.reload();
        });
        return element;
    }

    private async loadInventoryCount(): Promise<void> {
        try {
            const inventoryCount: number = await this._gameRouteService.getInventoryCount();
            this._inventoryCount = inventoryCount;
        }
        catch (error) {
            console.error("Failed to load inventory count:", error);
        }
    }

    private showInventoryCount(): void {
        if (this.shadowRoot) {
            const accusationText: HTMLElement = this.shadowRoot.querySelector(".accusationText")!;
            const itemsInInventory: HTMLElement = html`
                <h5>you have ${this._inventoryCount} items in your inventory.</h5>
            `;
            accusationText.appendChild(itemsInInventory);
            if (this._inventoryCount === 5) {
                const tipAccusation: HTMLElement = html`
                <h5>Consider searching for more item before making a decision.</h5>
            `;
                accusationText.appendChild(tipAccusation);
            }
        }
    }

    private showAccusationMonologue(): void {
        const accusationMessageWrong: HTMLElement | null | undefined = this.shadowRoot?.querySelector(".accusationMessageWrong");
        const accusationMessageRight: HTMLElement | null | undefined = this.shadowRoot?.querySelector(".accusationMessageRight");
        if (accusationMessageWrong) {
            if (this.characterName === "Chef") {
                const chefMonologue: HTMLElement = html`
                    <p>"Ha! Locking me up for this? Ridiculous.
                        My only crime is serving perfectly seasoned meals.
                        You think I poisoned him? If I wanted him dead,
                        I\’d have made sure it was quick. But fine.
                        Let’s see how long you all last without my cooking.
                        I give it two days before you come crawling back."
                    </p>
                `;
                accusationMessageWrong.appendChild(chefMonologue);
            }
            else if (this.characterName === "BusinessPartner") {
                const businessPartnerMonologue: HTMLElement = html`
                    <p>"Do you have any idea how much money we were about to make?
                        And now, thanks to your incompetence, I’m stuck in here instead of sealing deals.
                        You think I’d be foolish enough to kill my golden goose? Think again.
                        You’ve made a terrible mistake… and when I’m out, you’ll regret it."
                    </p>
                `;
                accusationMessageWrong.appendChild(businessPartnerMonologue);
            }
            else if (this.characterName === "Gardener") {
                const gardenerMonologue: HTMLElement = html`
                    <p>"I spent more time tending his roses than he ever spent
                        appreciating ‘em. Now they call me the killer? I wouldn’t
                        have wasted my time on the likes of him. If I ever took a life,
                        it’d be the weeds choking the garden—not some rich fool who didn’t
                        even know my name."
                    </p>
                `;
                accusationMessageWrong.appendChild(gardenerMonologue);
            }
            else if (this.characterName === "butler") {
                const butlerMonologue: HTMLElement = html`
                    <p>"Hmph. After all my years of loyal service, this is what I get?
                        I polished the silver, I brought the tea, I kept all his dirty little secrets!
                        And now I rot in here for a crime I didn’t commit?
                        I suppose that’s what loyalty earns a man these days…"
                    </p>
                `;
                accusationMessageWrong.appendChild(butlerMonologue);
            }
            if (accusationMessageRight) {
                if (this.characterName === "elizabeth") {
                    const widowMonologue: HTMLElement = html`
                        <p>"You fools… you actually think you’ve won? He deserved it!
                            That greedy, unfaithful bastard had it coming!
                            I gave him my life, my love, and for what? To be cast aside like an old relic?
                            No. If I had the chance, I’d do it again. Enjoy your little victory…
                            but you’ll always wonder—what else have I gotten away with?"
                        </p>
                    `;
                    accusationMessageRight.appendChild(widowMonologue);
                }
            }
        }
    }

    private backgroundImageCharacter(): void {
        const characterImage: HTMLElement = html`
            <img class="characterBackground" src="/assets/img/rooms/${this.characterName}.png">
        `;
        const jailImage: HTMLElement = html`
            <img class="jailBackground" src="/assets/img/rooms/prison.png">
        `;
        const starsBackground: HTMLElement = document.querySelector(".stars")!;
        const body: HTMLElement = document.querySelector("body")!;
        const overlay: HTMLElement = document.querySelector(".overlay")!;
        body.removeChild(starsBackground);
        overlay.appendChild(characterImage);
        overlay.appendChild(jailImage);
    }

    /**
     * Render the contents of this page
     */
    private async render(): Promise<void> {
        if (!this.shadowRoot) {
            return;
        }
        const elements: HTMLElement[] = htmlArray`
        <style>${styles}</style>
            <div class="accusationOption">
                <div class="accusationText">
                    <h1>Who is the murderer?</h1>
                    <p>click on the character to accuse.</p>
                </div>
                <div class="characters">
                    ${this.renderCharacters()}
                </div>
            </div>
            <div class="accusedWrong" hidden>
                <h1 class="lose">You lose...</h1>
                <h1>You have convicted the wrong person</h1>
                <div class="accusationMessageWrong"></div>
                ${this.playAgain()}
                
            </div>
            <div class="accusedRight" hidden>
                <h1 class="win">You win!</h1>
                <h1>You have convicted the right person</h1>
                <div class="accusationMessageRight"></div>
                ${this.playAgain()}
            </div>
        </div>
        `;
        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.append(...elements);
        await this.loadInventoryCount().then(_ => {
            this.showInventoryCount();
        });
    }
}
